export const START_LOADING = "START_LOADING"
export const START_LOADING_RESPONSE = "START_LOADING_RESPONSE"

export const FINISH_LOADING = "FINISH_LOADING"
export const FINISH_LOADING_RESPONSE = "FINISH_LOADING_RESPONSE"

export const RESET_LOADER = "RESET_LOADER"